import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { fromApiEffectSwitchMap } from '@lib/store';
import {
  cancelGetOrderResultRequest,
  failGetOrderResult,
  setGetOrderResult,
  setGetOrderResultFromApi,
  updateGetOrderResult,
  updateGetOrderResultFromApi,
} from './get-order-result.actions';

/**
 * Service to handle async GetOrderResult actions
 */
@Injectable()
export class GetOrderResultEffect {
  /**
   * Set the state with the reply content, dispatch failGetOrderResult if it catches a failure
   */
  public setFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setGetOrderResultFromApi),
      fromApiEffectSwitchMap(
        (reply, action) => setGetOrderResult({ model: reply, requestId: action.requestId }),
        (error, action) => of(failGetOrderResult({ error, requestId: action.requestId })),
        cancelGetOrderResultRequest
      )
    )
  );

  /**
   * Update the state with the reply content, dispatch failGetOrderResult if it catches a failure
   */
  public updateFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateGetOrderResultFromApi),
      mergeMap((payload) =>
        from(payload.call).pipe(
          map((reply) => updateGetOrderResult({ model: reply, requestId: payload.requestId })),
          catchError((err) => of(failGetOrderResult({ error: err, requestId: payload.requestId })))
        )
      )
    )
  );

  constructor(protected actions$: Actions) {}
}
